import { combineReducers } from 'redux';

import { cart } from './Reducers/Cart.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { languageAndCountry } from './Reducers/LanguageAndCountry.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import { product } from './Reducers/Product.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';

const staticReducers = {
    cart,
    checkout,
    facetedSearch,
    myPage,
    navigation,
    overlay,
    quickSearch,
    product,
    languageAndCountry,
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
